export default __webpack_public_path__ + "static/media/pcs_p.d74b3dc2.png";